import { useCallback, useContext } from "react";

import type { ContestManageModalType } from "../components/Modals/ContestManageModalsContext";
import { ContestManageModalsContext } from "../components/Modals/ContestManageModalsContext";

function useHandleTextClick() {
  const { openModal } = useContext(ContestManageModalsContext);

  return useCallback((e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;

    if (target.tagName === 'A') {
      const modalName = target.getAttribute('data-modal');

      if (!modalName) { return; }

      const modalPayload = (() => {
        const payload = target.getAttribute('data-modal-payload');

        if (!payload) { return; }

        try {
          return JSON.parse(decodeURIComponent(payload));
        } catch (error) {
          return null;
        }
      })();

      e.preventDefault();
      openModal({
        type: modalName,
        ...(modalPayload ?? {}),
      } as ContestManageModalType);
    }
  }, [openModal]);
}

export default useHandleTextClick;
